<script>
  import { onMount, onDestroy } from 'svelte';

  let nftData = [];
  let nextCursor = null;
  const limit = 50;
  const apiKey = "c5f94e172fcc4c56918a61a484002ebf";
  const collectionSlug = "0x888-1";



  onMount(() => {
    console.log('Component mounted, loading initial NFTs');
    loadMoreNFTs();
  });



  async function fetchNFTsByCollection() {
    const url = nextCursor 
      ? `https://api.opensea.io/api/v2/collection/${collectionSlug}/nfts?limit=${limit}&next=${nextCursor}`
      : `https://api.opensea.io/api/v2/collection/${collectionSlug}/nfts?limit=${limit}`;

    try {
      const response = await fetch(url, { headers: { 'X-API-KEY': apiKey } });
      if (!response.ok) {
        console.error(`HTTP error! status: ${response.status}`);
        return;
      }
      const data = await response.json();
      console.log(data); // Log the data to inspect the structure
      nftData = [...nftData, ...data.nfts];
      nextCursor = data.next;
    } catch (error) {
      console.error("Fetching error: ", error);
    }
  }

  async function loadMoreNFTs() {
    await fetchNFTsByCollection();
  }

  onMount(() => {
    console.log('Component mounted, loading initial NFTs');
    loadMoreNFTs();
  });

  onDestroy(() => {
    // Cleanup logic if necessary
  });
</script>

<div class="grid grid-cols-3 gap-4">
{#each nftData as nft (nft.identifier)}
  <div class="border p-4">
    <h2 class="text-xl font-bold">{nft.name || 'NFT Name Not Available'}</h2>
    {#if nft.contract && nft.identifier}
      <!-- Add console.log here to inspect the nft object -->
      {#if nft.image_url}
        <a href={`https://opensea.io/assets/${nft.contract}/${nft.identifier}`} target="_blank">
          <img class="w-full h-auto nft-image" src={nft.image_url} alt={nft.name || 'NFT Image'} />
        </a>
        <a href={`https://opensea.io/assets/${nft.contract}/${nft.identifier}`} target="_blank" class="buy-now-button">
          Buy Now
        </a>
      {:else}
        <p>Image not available</p>
      {/if}
    {:else}
      <p>Asset details not available</p>
    {/if}
  </div>
{/each}
</div>

<button on:click={loadMoreNFTs}>Load More</button>

<style>
  /* Ensures that the image does not overflow its container */
  .nft-image {
    max-width: 100%; /* Image can be as wide as its container, no more */
    height: auto; /* Maintains the aspect ratio */
    display: block; /* Removes any extra space below the image */
  }
  
  .buy-now-button {
    display: inline-block;
    margin-top: 8px;
    padding: 10px 15px;
    background-color: #2081e2;
    color: white;
    text-align: center;
    text-decoration: none;
    border-radius: 4px;
    font-weight: bold;
  }

  .buy-now-button:hover {
    background-color: #1868b7;
  }

  @media (max-width: 768px) {
    /* Adjust styles for mobile if needed */
  }

  .collection {
    max-width: 100%;
    overflow: hidden;
    /* Rest of your styles */
  }
</style>
